import {
  trigger,
  state,
  style,
  animate,
  transition,
  group,
  animateChild,
  query,
  animation,
} from '@angular/animations'

const animationTimeSlow = '2s'
const animationTimeNormal = '1s'
const animationTimeFast = '.5s'
const animationTimeFaster = '.2s'
const animationTimeBlink = '.1s'

const animationFuncAlt = 'linear'
const animationFunctIn = 'ease-in'
const animationFunctOut = 'ease-out'
const animationFuncInOut = 'ease-in-out'
const animationFuncInOutExpo = 'cubic-bezier(1, 0, 0, 1)'

/**
 * Widgets animations
 */

export const openCloseWidget = trigger('openCloseWidget', [
  state(
    'hide',
    style({
      height: '36px',
      padding: '0 24px',
      overflow: 'hidden',
    }),
  ),
  state(
    'show',
    style({
      height: '*',
      padding: '0 24px 24px 24px',
      overflow: 'visible',
    }),
  ),
  transition('hide <=> show', [
    group([
      query('@openCloseWidgetHeader', animateChild()),
      query('@openCloseWidgetContent', animateChild()),
      animate(
        `${animationTimeFaster} ${animationTimeBlink} ${animationFuncInOut}`,
      ),
    ]),
  ]),
])

export const openCloseWidgetHeader = trigger('openCloseWidgetHeader', [
  state('hide', style({ transform: 'translateY(0)' })),
  state('show', style({ transform: 'translateY(12px)' })),
  transition(
    'hide <=> show',
    animate(`${animationTimeFaster} ${animationFuncInOut}`),
  ),
])

export const openCloseWidgetContent = trigger('openCloseWidgetContent', [
  state('hide', style({ opacity: '0', transform: 'translateY(0)' })),
  state('show', style({ opacity: '1', transform: 'translateY(12px)' })),
  transition(
    'hide <=> show',
    animate(`${animationTimeFaster} ${animationFuncInOut}`),
  ),
])

export const openCloseMultiselect = trigger('openCloseMultiselect', [
  state('hide', style({ opacity: '0' })),
  state('show', style({ opacity: '1' })),
  transition(
    'hide <=> show',
    animate(`${animationTimeFaster} ${animationFuncInOut}`),
  ),
])

export const openCloseTwinAreas = trigger('openCloseTwinAreas', [
  state('hide', style({ height: '46px' })),
  state('show', style({ height: '*' })),
  transition(
    'hide <=> show',
    animate(`${animationTimeFaster} ${animationFuncInOut}`),
  ),
])

export const fadeInAnimation = animation([
  style({ opacity: 0 }),
  animate('250ms 250ms ease', style({ opacity: 1 })),
])

export const fadeOutAnimation = animation([
  animate('250ms ease', style({ opacity: 0 })),
])
